import { SkillBadge } from "@/components/SkillBadge";
interface SkillsListProps {
  skills?: string[];
}
export const SkillsList = ({
  skills
}: SkillsListProps) => {
  if (!skills || skills.length === 0) return null;
  return <div>
      <h3 className="mb-2 text-sm font-medium">Skills</h3>
      <div className="flex flex-wrap gap-1.5">
        {skills.map(skill => <SkillBadge key={skill} label={skill} />)}
      </div>
    </div>;
};